<div class="row match-height justify-content-center">
    <div class="col-md-9">
        <div class="content-wrapper container-xxl p-0">
            <div class="content-body">
            <app-content-header [contentHeader]="contentHeader"></app-content-header>
            <!-- Horizontal Wizard -->
            <section class="horizontal-wizard">
                <img height="90" [src]="'assets/images/networks.png'" alt="Networks" />
                <div id="stepper1" class="bs-stepper horizontal-wizard-example">
                <div class="bs-stepper-header">
                    <div class="step" data-target="#account-details">
                    <button class="step-trigger">
                        <span class="bs-stepper-box">1</span>
                        <span class="bs-stepper-label">
                        <span class="bs-stepper-title">Beneficiary</span>
                        <span class="bs-stepper-subtitle">Fill Beneficiary Details</span>
                        </span>
                    </button>
                    </div>
                    <div class="line"><i data-feather="chevron-right" class="font-medium-2"></i></div>
                    <div class="step" data-target="#personal-info">
                    <button class="step-trigger">
                        <span class="bs-stepper-box">2</span>
                        <span class="bs-stepper-label">
                        <span class="bs-stepper-title">Summary</span>
                        <span class="bs-stepper-subtitle">Transaction overview</span>
                        </span>
                    </button>
                    </div>
                    <div class="line"><i data-feather="chevron-right" class="font-medium-2"></i></div>
                    <div class="step" data-target="#address">
                    <button class="step-trigger">
                        <span class="bs-stepper-box">3</span>
                        <span class="bs-stepper-label">
                        <span class="bs-stepper-title">Receipt</span>
                        <span class="bs-stepper-subtitle">Transaction status</span>
                        </span>
                    </button>
                    </div>
                </div>
                <div class="bs-stepper-content">
                    <form (ngSubmit)="(HWForm.form.valid)" #HWForm="ngForm">
                    <div id="account-details" class="content">
                      <div class="row justify-content-center">
                        <div class="col-md-8">
                        <form #accountDetailsForm="ngForm">
                        <div class="content-header">
                            <h4 class="mb-0">Purchase</h4>
                            <small class="text-muted"><b>Enter Your Beneficiary Details.</b></small>
                        </div>
                        
                        <div class="row">
                            <div class="form-group col-md-12">
                            <label class="form-label" for="phone"><h6>Customer Phone</h6></label>
                            <input
                                [(ngModel)]="phone"
                                #TDFirstNameRef="ngModel"
                                required
                                type="text"
                                name="phone"
                                id="phone"
                                class="form-control"
                                [class.error]="personalInfoForm.submitted && TDFirstNameRef.invalid"
                                placeholder="Beneficiary Phone"
                            />
                            <span *ngIf="personalInfoForm.submitted && TDFirstNameRef.invalid" class="invalid-form">
                                <small class="form-text text-danger" *ngIf="TDFirstNameRef.errors.required"
                                >This field is required!</small
                                >
                            </span>
                            </div>
                            <div class="form-group col-md-12">
                                <label class="form-label" for="network"><h6>Biller Network</h6></label>
                                <ng-select (change)="selectNetwork($event)">
                                    <ng-option *ngFor="let item of selectBasic" [value]="item.category">{{item.category}}</ng-option>
                                </ng-select>
                            </div>
                            <div class="form-group col-md-12">
                                <label class="form-label" for="productCode"><h6>Biller Plan</h6></label>
                                <ng-select (change)="selectProduct($event)">
                                    <ng-option *ngFor="let item of selectProducts" [value]="item">{{ item.display_name }}</ng-option>
                                </ng-select>
                            </div>
                            <div class="form-group col-md-12">
                            <label class="form-label" for="amount"><h6>Amount (₦)</h6></label>
                            <input
                                [(ngModel)]="amount"
                                #TDLastNameRef="ngModel"
                                required
                                type="text"
                                name="amount"
                                id="amount"
                                disabled="true"
                                class="form-control"
                                [class.error]="personalInfoForm.submitted && TDLastNameRef.invalid"
                                placeholder="Amount"
                            />
                            <span *ngIf="personalInfoForm.submitted && TDLastNameRef.invalid" class="invalid-form">
                                <small class="form-text text-danger" *ngIf="TDLastNameRef.errors.required"
                                >This field is required!</small
                                >
                            </span>
                            </div>
                        </div>
    
                        <div class="d-flex justify-content-between">
                            <button
                            (click)="horizontalWizardStepperPrevious()"
                            class="btn btn-outline-secondary btn-prev"
                            disabled
                            rippleEffect
                            >
                            <i data-feather="arrow-left" class="align-middle mr-sm-25 mr-0"></i>
                            <span class="align-middle d-sm-inline-block d-none">Previous</span>
                            </button>
                            <button
                            (click)="horizontalWizardStepperNext(accountDetailsForm)"
                            type="submit"
                            class="btn btn-primary btn-next"
                            rippleEffect
                            >
                            <span class="align-middle d-sm-inline-block d-none">Next</span>
                            <i data-feather="arrow-right" class="align-middle ml-sm-25 ml-0"></i>
                            </button>
                        </div>
                        </form>
                        </div>
                        </div>
                    </div>
                    <div id="personal-info" class="content">
                        <form #personalInfoForm="ngForm">
    
                        <div class="row justify-content-center">
                            <div class="col-md-8">
    
                        <div class="content-header">
                            <h4 class="mb-0">Summary</h4>
                            <small>Confirm Transaction.</small>
                        </div>
    
                        <ul class="list-group mb-2">
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                              Beneficiary Phone
                              <span class=""><b>{{ phone }}</b></span>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                              Biller Network
                              <span class=""><b>{{ network }}</b></span>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                Biller Plan
                                <span class=""><b>{{ productName }}</b></span>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                              Amount
                              <span class=""><b>{{ amount | currency: "₦" }}</b></span>
                            </li>
                        </ul>
    
                        <div class="form-group">
                            <label class="form-label" for="trxPin"><h6>Transaction PIN</h6></label>
                            <input
                                [(ngModel)]="trxPin"
                                required
                                type="text"
                                name="trxPin"
                                id="trxPin"
                                class="form-control"
                                placeholder="Transaction PIN"
                            />
                        </div>
        
                        <div class="d-flex justify-content-between">
                            <button
                            type="button"
                            (click)="horizontalWizardStepperPrevious()"
                            class="btn btn-primary btn-prev"
                            rippleEffect
                            >
                            <i data-feather="arrow-left" class="align-middle mr-sm-25 mr-0"></i>
                            <span class="align-middle d-sm-inline-block d-none">Previous</span>
                            </button>
                            <button
                            (click)="proceedPayment(personalInfoForm)"
                            [disabled]="disable"
                            class="btn btn-primary btn-next"
                            rippleEffect
                            >
                            <span *ngIf="submitted" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            <span *ngIf="!submitted" class="align-middle d-sm-inline-block d-none">Proceed</span>
                            <i data-feather="arrow-right" class="align-middle ml-sm-25 ml-0"></i>
                            </button>
                        </div>
                        </div>
                        </div>
                        </form>
                    </div>
                    <div id="address" class="content">
                        
                        <div class="row justify-content-center">
                            <div class="col-md-8">
                        
                            <div id="print-receipt">
                        <div class="content-header d-flex justify-content-between align-items-center">
                            <div class="">
                                <h5 class="mb-0">Receipt</h5>
                                <small>Order Receipt.</small>
                            </div>
                            <h5>{{ siteSettings.site_name }}</h5>
                        </div>
    
                        <ul class="list-group mb-2">
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                Agent
                                <span class=""><b>{{ user.name }}</b></span>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                              Beneficiary Phone
                              <span class=""><b>{{ phone }}</b></span>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                Biller Plan
                                <span class=""><b>{{ productName }}</b></span>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                              Biller Network
                              <span class=""><b>{{ network }}</b></span>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                              Amount
                              <span class=""><b>{{ amount | currency: "₦" }}</b></span>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                Transaction Reference
                                <span class=""><b>{{ transactionRef.trans_id }}</b></span>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                Transaction Status
                                <span class="text-success"><b>Completed</b></span>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                Date
                                <span class=""><b>{{ transactionRef.created_at }}</b></span>
                            </li>
                        </ul>
                        </div>
        
                        <div class="d-flex justify-content-between">
                            <button
                            type="button"
                            (click)="print()"
                            class="btn btn-primary btn-prev"
                            rippleEffect
                            >
                            <i data-feather="printer" class="align-middle mr-sm-25 mr-0"></i>
                            <span class="align-middle d-sm-inline-block d-none">Print</span>
                            </button>
                            <button
                            (click)="startAgain()"
                            class="btn btn-primary btn-next"
                            rippleEffect
                            >
                            <span class="align-middle d-sm-inline-block d-none">Buy Again</span>
                            <i data-feather="arrow-right" class="align-middle ml-sm-25 ml-0"></i>
                            </button>
                        </div>
                            </div>
                            </div>
                    </div>
                    </form>
                </div>
                </div>
            </section>
            <!--/ Horizontal Wizard -->
    
            </div>
        </div>
    </div>
    </div>
      